// @flow
export { default } from './ProductsTagItem';



// WEBPACK FOOTER //
// ./src/components/tags/ProductsTagItem/index.js